// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-analytics h2.title {
  font-weight: 400;
  font-size: 2.2vw;
  color: #3a3a3a;
  margin: 4vw 0;
}
.product-analytics .spinner-container {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
}
.product-analytics .product-details {
  background: radial-gradient(100% 100% at 0% 0%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%);
  border-radius: 0.20868vw;
  border: 2px solid;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  border-image-source: linear-gradient(169.15deg, rgba(255, 255, 255, 0.4) 0%, rgba(238, 237, 237, 0.2) 96.79%);
  padding: 1vw;
  background-color: #fff;
}
.product-analytics .product-details table thead {
  background-color: #f9f9f9;
}
.product-analytics .product-details table thead th p {
  font-size: 0.85vw;
  padding: 1vw 0;
}
.product-analytics .product-details table p {
  font-weight: 400;
  color: #3a3a3a;
}
.product-analytics .product-details table tbody td {
  padding: 1vw;
  border-color: #e4e4e4;
}
.product-analytics .product-details table tbody td .image-container {
  display: flex;
  justify-content: center;
}
.product-analytics .product-details table tbody td .image-container img {
  width: 3.59vw;
  height: 3.59vw;
  object-fit: fill;
}
.product-analytics .product-details table tbody td p {
  font-size: 0.952vw;
}
.product-analytics .btn-container {
  margin-top: 2vw;
  text-align: right;
}
.product-analytics .btn-container button {
  background-color: #ee3a24;
  font-size: 0.952vw;
  font-weight: 500;
  border: none;
  border-radius: 0.2vw;
  padding: 0 5vw;
}
.product-analytics .btn-container button svg {
  position: relative;
  top: 2px;
  right: -3px;
}
.product-analytics .scrollable-container {
  max-height: 50vh;
  overflow-y: scroll;
}
.product-analytics .scrollable-container::-webkit-scrollbar {
  width: 0.5vw;
}
.product-analytics .scrollable-container::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}
.product-analytics .scrollable-container::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 10px;
}
.product-analytics .image-container-skeleton div {
  width: 50px;
  height: 50px;
  margin: 0 auto;
  border-radius: 0.5vw;
  animation: skeleton-loading 5s infinite;
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 1000% 100%;
}
.product-analytics .paragraph-skeleton {
  width: 50%;
  margin: 0 auto;
  height: 1.8vw;
  border-radius: 0.2vw;
  animation: skeleton-loading 5s infinite;
  background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
  background-size: 1000% 100%;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/style/components/store/ProductAnalytic.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AAAJ;AAEE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;AAAJ;AAEE;EACE,yGAAA;EAKA,wBAAA;EACA,iBAAA;EACA,+DAAA;EACA,6GAAA;EAKA,YAAA;EACA,sBAAA;AARJ;AAUM;EACE,yBAAA;AARR;AAUU;EACE,iBAAA;EACA,cAAA;AARZ;AAYM;EACE,gBAAA;EACA,cAAA;AAVR;AAaQ;EACE,YAAA;EACA,qBAAA;AAXV;AAYU;EACE,aAAA;EACA,uBAAA;AAVZ;AAWY;EACE,aAAA;EACA,cAAA;EACA,gBAAA;AATd;AAYU;EACE,kBAAA;AAVZ;AAiBE;EACE,eAAA;EACA,iBAAA;AAfJ;AAgBI;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;AAdN;AAeM;EACE,kBAAA;EACA,QAAA;EACA,WAAA;AAbR;AAiBE;EACE,gBAAA;EACA,kBAAA;AAfJ;AAkBE;EACE,YAAA;AAhBJ;AAmBE;EACE,uBAAA;EACA,mBAAA;AAjBJ;AAoBE;EACE,mBAAA;EACA,mBAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EAEA,uCAAA;EACA,yEAAA;EACA,2BAAA;AApBJ;AAsBE;EACE,UAAA;EACA,cAAA;EACA,aAAA;EACA,oBAAA;EAEA,uCAAA;EACA,yEAAA;EACA,2BAAA;AArBJ;;AAyBA;EACE;IACE,2BAAA;EAtBF;EAwBA;IACE,4BAAA;EAtBF;AACF","sourcesContent":[".product-analytics {\n  h2.title {\n    font-weight: 400;\n    font-size: 2.2vw;\n    color: #3a3a3a;\n    margin: 4vw 0;\n  }\n  .spinner-container {\n    position: absolute;\n    width: calc(100%);\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    left: 0;\n  }\n  .product-details {\n    background: radial-gradient(\n      100% 100% at 0% 0%,\n      rgba(255, 255, 255, 0.4) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n    border-radius: 0.20868vw;\n    border: 2px solid;\n    box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n    border-image-source: linear-gradient(\n      169.15deg,\n      rgba(255, 255, 255, 0.4) 0%,\n      rgba(238, 237, 237, 0.2) 96.79%\n    );\n    padding: 1vw;\n    background-color: #fff;\n    table {\n      thead {\n        background-color: #f9f9f9;\n        th {\n          p {\n            font-size: 0.85vw;\n            padding: 1vw 0;\n          }\n        }\n      }\n      p {\n        font-weight: 400;\n        color: #3a3a3a;\n      }\n      tbody {\n        td {\n          padding: 1vw;\n          border-color: #e4e4e4;\n          .image-container {\n            display: flex;\n            justify-content: center;\n            img {\n              width: 3.59vw;\n              height: 3.59vw;\n              object-fit: fill;\n            }\n          }\n          p {\n            font-size: 0.952vw;\n          }\n        }\n      }\n    }\n  }\n\n  .btn-container {\n    margin-top: 2vw;\n    text-align: right;\n    button {\n      background-color: #ee3a24;\n      font-size: 0.952vw;\n      font-weight: 500;\n      border: none;\n      border-radius: 0.2vw;\n      padding: 0 5vw;\n      svg {\n        position: relative;\n        top: 2px;\n        right: -3px;\n      }\n    }\n  }\n  .scrollable-container {\n    max-height: 50vh;\n    overflow-y: scroll;\n  }\n\n  .scrollable-container::-webkit-scrollbar {\n    width: 0.5vw;\n  }\n\n  .scrollable-container::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 10px;\n  }\n\n  .scrollable-container::-webkit-scrollbar-thumb {\n    background: #d9d9d9;\n    border-radius: 10px;\n  }\n\n  .image-container-skeleton div {\n    width: 50px;\n    height: 50px;\n    margin: 0 auto;\n    border-radius: 0.5vw;\n\n    animation: skeleton-loading 5s infinite;\n    background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);\n    background-size: 1000% 100%;\n  }\n  .paragraph-skeleton {\n    width: 50%;\n    margin: 0 auto;\n    height: 1.8vw;\n    border-radius: 0.2vw;\n\n    animation: skeleton-loading 5s infinite;\n    background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);\n    background-size: 1000% 100%;\n  }\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
